import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../helpers/export'
import MacroeconomicsService from './service'

export const exportMacroeconomics = createAsyncThunk(
  'companyAnalysis/industryOverview/macroeconomics/exportMacroeconomics',
  async (params) => {
    try {
      const res = await MacroeconomicsService.exportMacroeconomics(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
